export default __webpack_public_path__ + "static/mariadb-3577539ecf75f55dd2291e30525f8bf1.png";